import { getData } from '../generic';

import { cAPI } from '../../../utils/cAPI';

export const getReports = () => dispatch => getData(dispatch, cAPI.APGetReports, null, 'reports');
export const getReport = id => dispatch => getData(dispatch, cAPI.APGetReport, id, 'reports');
